import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { usePageTitle } from "../components/common";

export default function PaymentCancel() {
  usePageTitle("Paiement annulé");
  return (
    <div className="container-x py-20 sm:py-28 fade-up">
      <div className="max-w-xl mx-auto text-center card-soft p-10">
        <div className="w-16 h-16 rounded-full bg-[#D3AAA8]/25 flex items-center justify-center mx-auto">
          <XCircle className="text-[#7A5D58]" size={30} />
        </div>
        <h1 className="mt-6 font-serif text-3xl font-medium text-[#5A3A4B]">Ton paiement n'a pas été finalisé</h1>
        <p className="mt-4 text-[#7A5D58] leading-relaxed">
          Aucun prélèvement confirmé n'a été enregistré. Ta séance n'est donc pas encore réservée.
          Tu peux reprendre ta commande lorsque tu le souhaites, en toute sérénité.
        </p>
        <Link to="/guidances" className="btn-primary mt-8" data-testid="cancel-back-btn">
          Reprendre ma commande
        </Link>
      </div>
    </div>
  );
}
